import { ToggleCard } from '@ori-ui/components';
import { styled, Typography } from '@ori-ui/mui';
import { forwardRef, useContext } from 'react';

import { wizardContext } from '../../contexts';
import type { CustomerSelectionProps } from '../../types';
import { EWizardCustomerType } from '../../types';
import { FormattedMessage } from '../FormattedMessage';

interface StyleProps {
  selected: boolean;
}

const SelectedBoldTypography = styled(Typography)<{ ownerState: StyleProps }>(({ ownerState }) => ({
  ...(ownerState.selected && { fontWeight: 'bold' }),
}));

export const MyselfSection = forwardRef<HTMLInputElement, CustomerSelectionProps>(
  ({ selected, value, onChange }, ref) => {
    const { customerType } = useContext(wizardContext);

    if (customerType === EWizardCustomerType.OnlyForOtherCustomers) {
      return null;
    }

    return (
      <ToggleCard
        checked={selected}
        name="consultant-option"
        type="radio"
        id="myself"
        value={value}
        onChange={onChange}
      >
        <SelectedBoldTypography ownerState={{ selected }}>
          <FormattedMessage id="myself" />
        </SelectedBoldTypography>
      </ToggleCard>
    );
  },
);
